<template>
    <TermsCheck
        :content="listText"
        :is-loading="isLoading"
        @goNext="goNext"
    />
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAgreeTermsB1, postAgreeB1 } from '@/apis/B1';
import routeName from '@/router/constant.js';
import TermsCheck from '@/components/template/TermsCheck.vue';

export default {
    components: {
        TermsCheck
    },
    setup() {
        const router = useRouter();
        const listText = ref('');
        const isLoading = ref(false);

        /** 取得條款內容 */
        getAgreeTermsB1().then((res) => {
            listText.value = res.data.agreeTerms.content;
        });

        // const goNext = () => {
        //     console.log(router.push({
        //         name: routeName.PAYMENT_PERIOD
        //     }).catch(err => {
        //         console.log(err);
        //     }));
        //     router.push({
        //         name: routeName.PAYMENT_PERIOD
        //     }).catch(err => {
        //         console.log(err);
        //     });
        // };
        const goNext = () => {
            isLoading.value = true;
            postAgreeB1().then(res => {
                router.push({
                    name: routeName.PAYMENT_PERIOD
                }).catch(err => { console.log(err); });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            listText,
            isLoading,
            goNext
        };
    },
};
</script>
